<template>
    <section id="section">
        <div class="main cb">
            <div class="tab-lists-container">
                <div class="tab-title-container">
                    <div class="tab-m-title-container">
                        <i class="icon-studio"></i>
                        <span class="tab-m-title">{{name}}</span>
                    </div>
                </div>
                <div class="tab-border-container">
                    <div class="tab-s-border"></div>
                    <div class="tab-m-border"></div>
                </div>
            </div>

            <div class="slider-container" v-if="slides.length">
                <el-carousel indicator-position="outside" height="21vw">
                    <el-carousel-item v-for="(v, k) in slides" :key="k" :style="`background-image:url(${v});`"></el-carousel-item>
                </el-carousel>
            </div>

            <div class="info-box">
                <div class="info" v-show="address"> <strong>门店地址 :</strong> &nbsp;&nbsp;{{address}}</div>
                <div class="info" v-show="phone"> <strong>联系方式 :</strong> &nbsp;&nbsp;{{phone}}</div>
                <div class="info" v-show="offtime"> <strong>营业时间 :</strong> &nbsp;&nbsp;{{offtime}}</div>
            </div>
        </div>

        <div class="tab-lists-container">
            <div class="tab-title-container">
                <div class="tab-m-title-container">
                    <i class="icon-course"></i>
                    <span class="tab-m-title">课程安排</span>
                </div>
            </div>
            <div class="tab-border-container">
                <div class="tab-s-border"></div>
                <div class="tab-m-border"></div>
            </div>
        </div>

        <img v-lazy="card.replace(/p:\/\/i/, 'ps://i')" alt="">

    </section>
</template>

<script>
    export default {
        data: () => ({
            slides: [],
            name: '',
            long: 0,
            lat: 0,
            offtime: '',
            phone: 0,
            address: '',
            card: '',
        }),
        beforeMount() {
            this.api.get(`stores/${this.$route.params.id}`).then(e => {
                this.slides = e.slides;
                this.name = e.name;
                this.long = e.long;
                this.lat = e.lat;
                this.phone = e.phone;
                this.address = e.address;
                this.offtime = e.offtime;
                this.card = e.card;
            }, () => {});
        }
    }
</script>

<style scoped>
    @import "../../../static/css/common/tab.css";
    .slider-container {
        cursor: pointer;
        width: 31vw;
        float: left;
        margin-right: 20px;
    }

    .info-box {
        margin-top: 20px;
        float: left;
    }

    .info {
        margin-bottom: 15px;
    }

    .course-title {
        font-size: 20px;
        margin-bottom: 10px;
    }

    .tab-lists-container {
        margin-top: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/views/store/index.vue